export const logo = require("./logo.png");
export const totalcustomer = require("./icons/total-customer.png");
export const totolproowner = require("./icons/total-proowner.png");
export const totalrecep = require("./icons/total-receptionist.png");
export const totalemp = require("./icons/total-employee.png");
export const totalproper = require("./icons/total-property.png");
export const totalrooms = require("./icons/total-rooms.png");
export const receivebooking = require("./icons/receive-booking.png");
export const completedbooking = require("./icons/completed-booking.png");
export const completedbookingcount = require("./icons/cancel-booking-count.png");
export const requestreceived = require("./icons/request-received.png");
export const requestaccepted = require("./icons/request-accepted.png");
export const requestreject = require("./icons/request-rejected.png");
export const requestpending = require("./icons/request-pending.png");
export const statecoverd = require("./icons/state-coverd.png");
export const citycovered = require("./icons/city-covered.png");
export const locationcoverd = require("./icons/location-coverd.png");
export const bookingday = require("./icons/booking-day.png");
export const gettogthercount = require("./icons/gettogther-count.png");
export const dayouting = require("./icons/dayouting.png");
export const justwalking = require("./icons/justwalking.png");
export const roomsharing = require("./icons/room-sharing.png");
export const successfulcheckin = require("./icons/successful-checkin.png");
export const successfulcheckout = require("./icons/successful-checkout.png");
export const unsuccessfulcheckin = require("./icons/unsuccessful-checkin.png");
export const tomarrowbooking = require("./icons/tomarrow-booking.png");
export const futurebooking = require("./icons/future-booking.png");
export const moneyredeem = require("./icons/money-redeem.png");
export const moneyutilized = require("./icons/money-utilized.png");
export const moneyexpired = require("./icons/money-expired.png");
export const cancelbooking = require("./icons/cancel-booking.png");
export const currentblockedrooms = require("./icons/current-blocked-rooms.png");
export const futureblockedroom = require("./icons/future-blocked-room.png");
export const recommendedproperty = require("./icons/recommended-property.png");
export const recommendedunsubproperty = require("./icons/recommended-unsub-property.png");
export const mmcsubsproperty = require("./icons/mmc-subs-property.png");
export const mmcunsubsproperty = require("./icons/mmc-unsubs-property.png");
export const bookingrevenue = require("./icons/booking-revenue.png");
export const recommendationrevenue = require("./icons/recommendation-revenue.png");
export const mmcrevenue = require("./icons/mmc-revenue.png");
export const tiprevenue = require("./icons/tip-revenue.png");
export const overallrevenue = require("./icons/overall-revenue.png");
export const debitoutstanding = require("./icons/debit-outstanding.png");
export const creditoutstanding = require("./icons/credit-outstanding.png");
export const recommendationprofit = require("./icons/recommendation-profit.png");
export const mmcprofit = require("./icons/mmc-profit.png");
export const tipsprofit = require("./icons/tips-profit.png");
export const overallprofit = require("./icons/overall-profit.png");
export const editIcon = require("./icons/edit_role.png");
export const viewIcon = require("./icons/view_icon.png");
export const sorgamseasideicon = require("./property/sorgam-seaside-villa.jpg");
